export default __webpack_public_path__ + "static/media/receivers.a6ce9113.svg";